import { render } from "./FixtureMatches.vue?vue&type=template&id=16ea0249"
import script from "./FixtureMatches.vue?vue&type=script&lang=js"
export * from "./FixtureMatches.vue?vue&type=script&lang=js"

import "./FixtureMatches.vue?vue&type=style&index=0&id=16ea0249&lang=css"

import exportComponent from "C:\\Users\\HS\\Desktop\\fikstur\\my_fiksture\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__